import { render, staticRenderFns } from "./Visit-Detail.vue?vue&type=template&id=10b6cecc&scoped=true"
import script from "./Visit-Detail.vue?vue&type=script&lang=js"
export * from "./Visit-Detail.vue?vue&type=script&lang=js"
import style0 from "./Visit-Detail.vue?vue&type=style&index=0&id=10b6cecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6cecc",
  null
  
)

export default component.exports